// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import TipTap from "../../RichTextEditor/Tiptap";
// import "./BlogAdd.css"; // Import the CSS module
// import axios from "axios";

// const BlogAdd = () => {
//   const [careerId, setCareerId] = useState();
//   const [careers, setCareers] = useState([]);
//   const [title, setTitle] = useState();
//   const [language, setLanguage] = useState();
//   const [content, setContent] = useState();
//   const navigate = useNavigate();
//   const API_BASE_URL = process.env.REACT_APP_API_BASEURL;

//   const fetchAllCareers = () => {
//     axios
//       .get(`${API_BASE_URL}/careerCategories`)
//       .then((response) => {
//         setCareers(response.data?.data);
//       })
//       .catch((error) => {
//         console.error("Error fetching careers:", error);
//       });
//   };

//   useEffect(() => {
//     fetchAllCareers();
//   }, []);

//   const handleAddNewBlog = () => {
//     navigate("/add-blog");
//   };
//   const handleViewAllBlog = () => {
//     navigate("/all-blog");
//   };
//   function getContent(htmlContent) {
//     console.log("content download here", htmlContent);
//     setContent(htmlContent);
//   }

//   // const handleSubmit = async (e) => {
//   //   e.preventDefault();
//   //   // console.log({ careerId, title, language, content });
//   //   // Validate form data
//   //   // if (!careerId || !title || !language || !content) {
//   //   //   alert("All fields are required!");
//   //   //   return;
//   //   // }
//   //   console.log("===================",content)

//   //   // Create the blog data object

//   //   const blogData = {
//   //     careerId,
//   //     title,
//   //     language,
//   //     content,
//   //   };
//   //   // console.log("----->>>", content);

//   //   try {
//   //     // Post data to the API
//   //     const response = await axios.post(
//   //       `${API_BASE_URL}/admin/blogs`,
//   //       blogData,
//   //       {
//   //         headers: {
//   //           Authorization: `Bearer ${localStorage.getItem("token")}`,
//   //         },
//   //       }
//   //     );
//   //     console.log(response);
//   //     if (response.status === 201) {
//   //       alert("Blog added successfully!");
//   //       navigate("/all-blog"); // Redirect to "All Blog" page
//   //     } else {
//   //       alert("Failed to add blog. Please try again.");
//   //     }
//   //   } catch (error) {
//   //     console.error("Error adding blog:", error);
//   //     alert("An error occurred while adding the blog.");
//   //   }
//   // };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     // Log content to verify
//     console.log("Full Blog Content:", content);

//     // Validate that content exists
//     if (!content || content.trim() === "<p></p>") {
//       alert("Please add blog content!");
//       return;
//     }

//     const blogData = {
//       careerId,
//       title,
//       language,
//       content,
//     };

//     try {
//       const response = await axios.post(
//         `${API_BASE_URL}/admin/blogs`,
//         blogData,
//         {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//           },
//         }
//       );

//       if (response.status === 201) {
//         alert("Blog added successfully!");
//         navigate("/all-blog");
//       } else {
//         alert("Failed to add blog. Please try again.");
//       }
//     } catch (error) {
//       console.error("Error adding blog:", error);
//       alert("An error occurred while adding the blog.");
//     }
//   };
//   return (
//     <div className="blogAddContainer">
//       <div className="blogAddHeader">
//         <h5>Blog</h5>
//         <div className="blogAddButtonGroup">
//           <button className="blogAddAddButton" onClick={handleAddNewBlog}>
//             + Add New Blog
//           </button>
//           <button className="blogAddViewAllButton" onClick={handleViewAllBlog}>
//             All Blog
//           </button>
//         </div>
//       </div>

//       <div className="blogAddFormContainer">
//         <h4 className="blogAddFormTitle">Blog Details</h4>
//         <form className="blogAddForm">
//           <div className="blogAddInputGroup">
//             <label className="blogAddLabel">Select Career</label>
//             <select
//               className="blogAddSelect"
//               value={careerId}
//               onChange={(e) => setCareerId(e.target.value)}
//               required
//             >
//               <option value="">-Select Career-</option>
//               {careers.map((career) => (
//                 <option value={career._id} key={career._id}>
//                   {career?.name}
//                 </option>
//               ))}
//             </select>
//           </div>

//           <div className="blogAddInputGroup">
//             <label className="blogAddLabel">Blog Title</label>
//             <input
//               type="text"
//               placeholder="Enter Title"
//               className="blogAddInput"
//               value={title}
//               onChange={(e) => setTitle(e.target.value)}
//               required
//             />
//           </div>

//           <div className="blogAddInputGroup">
//             <label className="blogAddLabel">-Select Language-</label>
//             <select
//               className="blogAddSelect"
//               value={language}
//               onChange={(e) => setLanguage(e.target.value)}
//               required
//             >
//               <option>-Select Language-</option>
//               <option value="english">English</option>
//               <option value="hindi">Hindi</option>
//             </select>
//           </div>

//           <div className="blogAddFullWidth">
//             <label className="blogAddLabel">Blog Contant</label>
//             <TipTap setContent={setContent} setContentDetails={getContent} />
//           </div>

//           <div className="blogAddButtonGroup">
//             <button onClick={handleSubmit} className="blogAddSaveButton">
//               Save
//             </button>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default BlogAdd;





import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./BlogAdd.css";
import axios from "axios";

const BlogAdd = () => {

  const [careerId, setCareerId] = useState("");
  const [careers, setCareers] = useState([]);
  const [title, setTitle] = useState("");
  const [language, setLanguage] = useState("");
  const [pdfFile, setPdfFile] = useState(null);

  const navigate = useNavigate();

  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;


  /* FETCH CAREERS */
  const fetchAllCareers = () => {

    axios
      .get(`${API_BASE_URL}/careerCategories`)
      .then((response) => {

        setCareers(response.data?.data || []);

      })
      .catch((error) => {

        console.error("Error fetching careers:", error);

      });

  };


  useEffect(() => {

    fetchAllCareers();

  }, []);



  /* BUTTON HANDLERS */
  const handleAddNewBlog = () => {

    navigate("/add-blog");

  };


  const handleViewAllBlog = () => {

    navigate("/all-blog");

  };



  /* HANDLE PDF CHANGE */
  const handleFileChange = (e) => {

    const file = e.target.files[0];

    if (!file) return;

    if (file.type !== "application/pdf") {

      alert("Only PDF files allowed");
      return;

    }

    setPdfFile(file);

  };



  /* HANDLE SUBMIT */
  const handleSubmit = async (e) => {

    e.preventDefault();

    if (!careerId || !title || !language || !pdfFile) {

      alert("All fields including PDF file are required");
      return;

    }

    try {

      const formData = new FormData();

      formData.append("careerId", careerId);
      formData.append("title", title);
      formData.append("language", language);
      formData.append("pdfFile", pdfFile);


      const role = localStorage.getItem("role");
      const endpoint =
        role === "subAdmin"
          ? `${API_BASE_URL}/subadmin/blogs`
          : `${API_BASE_URL}/admin/blogs`;


      const response = await axios.post(

        // `${API_BASE_URL}/admin/blogs`,
        endpoint,
        formData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }

      );


      if (response.status === 201) {

        alert("Blog added successfully!");
        navigate("/all-blog");

      }

    }
    catch (error) {

      console.error("Upload error:", error);

      alert(
        error.response?.data?.msg ||
        "Error uploading blog"
      );

    }

  };



  return (

    <div className="blogAddContainer">

      {/* HEADER */}
      <div className="blogAddHeader">

        <h5>Blog</h5>

        <div className="blogAddButtonGroup">

          <button
            className="blogAddAddButton"
            onClick={handleAddNewBlog}
            type="button"
          >
            + Add New Blog
          </button>

          <button
            className="blogAddViewAllButton"
            onClick={handleViewAllBlog}
            type="button"
          >
            All Blog
          </button>

        </div>

      </div>



      {/* FORM */}
      <div className="blogAddFormContainer">

        <h4 className="blogAddFormTitle">Blog Details</h4>

        <form
          className="blogAddForm"
          onSubmit={handleSubmit}
        >



          {/* CAREER */}
          <div className="blogAddInputGroup">

            <label>Select Career</label>

            <select
              className="blogAddSelect"
              value={careerId}
              onChange={(e) =>
                setCareerId(e.target.value)
              }
              required
            >

              <option value="">
                -Select Career-
              </option>

              {careers.map((career) => (

                <option
                  key={career._id}
                  value={career._id}
                >
                  {career.name}
                </option>

              ))}

            </select>

          </div>



          {/* TITLE */}
          <div className="blogAddInputGroup">

            <label>Blog Title</label>

            <input
              type="text"
              className="blogAddInput"
              placeholder="Enter Title"
              value={title}
              onChange={(e) =>
                setTitle(e.target.value)
              }
              required
            />

          </div>



          {/* LANGUAGE */}
          <div className="blogAddInputGroup">

            <label>Select Language</label>

            <select
              className="blogAddSelect"
              value={language}
              onChange={(e) =>
                setLanguage(e.target.value)
              }
              required
            >

              <option value="">
                -Select Language-
              </option>

              <option value="english">
                English
              </option>

              <option value="hindi">
                Hindi
              </option>

            </select>

          </div>



          {/* PDF FILE */}
          <div className="blogAddInputGroup">

            <label>Upload PDF</label>

            <input
              type="file"
              accept="application/pdf"
              onChange={handleFileChange}
              required
            />

          </div>



          {/* SUBMIT */}
          <div className="blogAddButtonGroup">

            <button
              type="submit"
              className="blogAddSaveButton"
            >
              Save Blog
            </button>

          </div>


        </form>

      </div>

    </div>

  );

};

export default BlogAdd;
